<template>
  <div
    id="app-component"
    v-if="hasInit"
    class="box-border flex flex-col min-h-screen ie-h-full"
  >
    <nav-bar class="print:hidden" />
    <div class="print:hidden" id="modal-container" />
    <offline-alert class="print:hidden" v-show="isDisconnected" />
    <popup class="print:hidden" />
    <loader class="print:hidden" :isShowing="isLoading" />
    <div
      :class="{
        'flex-no-grow':
          $route.name != 'Home' &&
          $route.name != 'Login' &&
          $route.name != 'Maintenance' &&
          $route.name != 'Prelaunch',
        'tmsk-sky-blue-bg': [
          'Home',
          'Maintenance',
          'NotFound',
          'Prelaunch',
        ].includes($route.name),
        'flex items-center': $route.name === 'NotFound',
      }"
      class="flex-1 content-flex"
    >
      <router-view />
    </div>
    <full-width
      :bg="
        ['Home', 'Maintenance', 'NotFound', 'Prelaunch'].includes($route.name)
          ? 'tmsk-sky-blue-bg'
          : ''
      "
      padding="pt-4 sm:pt-0 print:hidden"
    >
      <img
        v-if="$route.name === 'LocateVendingMachines'"
        src="@/assets/img/locate-vending-machine-footer-SM06.png"
        class="w-full max-w-md px-4 mx-auto mt-12"
      />
      <img
        v-if="
          ![
            'NotFound',
            'Maintenance',
            'LocateVendingMachines',
            'Home',
            'Prelaunch',
          ].includes($route.name)
        "
        src="@/assets/img/home-illustration1.svg"
        class="w-full max-w-md px-4 mx-auto mt-12"
      />
    </full-width>
    <app-footer class="print:hidden" />
    <modal
      :displayModal="consentModal"
      :displayShade="consentShade"
      @hide-all="handleAcceptConsent"
      @show-modal="consentModal = true"
      :allowClose="false"
    >
      <div class="text-center">
        <h2
          class="text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
        >
          Important Privacy Notice
        </h2>
        <p
          class="max-w-2xl mx-auto text-base leading-7 text-center tmsk-blue-text"
        >
          By proceeding, you are agreeing to our
          <a
            class="underline cursor-pointer"
            @click="openUrl('https://stayprepared.sg/staymasked/terms-of-use/')"
            >Terms of Use</a
          >
          and
          <a
            class="underline cursor-pointer"
            @click="
              openUrl('https://stayprepared.sg/staymasked/privacy-statement/')
            "
            >Privacy Statement</a
          >
        </p>
      </div>

      <div
        class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
      >
        <span class="flex w-full rounded-full shadow-sm sm:col-start-2">
          <button
            type="button"
            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white border border-transparent rounded-full tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
            @click="handleAcceptConsent"
          >
            Proceed
          </button>
        </span>
      </div>
    </modal>
  </div>
</template>

<script>
import beepAPI from '@/mixins/beepAPI'
import OfflineAlert from '@/components/OfflineAlert'
import NavBar from '@/components/NavBar'
import Loader from '@/components/Loader'
import AppFooter from '@/components/Footer'
import Modal from '@/components/Modal'
import Popup from '@/components/popup/Popup'
import FullWidth from '@/components/Layout/FullWidth'
import { mapState, mapMutations, mapActions } from 'vuex'
import { verifyPassword } from '../src/views/authentication/Authentication.repo'
export default {
  name: 'App',
  components: {
    OfflineAlert,
    NavBar,
    Loader,
    AppFooter,
    Modal,
    FullWidth,
    Popup
  },
  mixins: [beepAPI],
  props: {},
  data () {
    return {
      isDisconnected: false,
      consentModal: false,
      consentShade: false,
      hasInit: false
    }
  },
  computed: {
    ...mapState(['isLoading', 'bypassSuccess'])
  },
  watch: {
    bypassSuccess (newVal) {
      if (newVal) {
        this.handleInitCookiesAndParams()
      }
    }
  },

  // Lifecycle Hooks
  beforeCreate () {
    window.addEventListener(
      'online',
      () => {
        this.isDisconnected = false
      }
    )
    window.addEventListener(
      'offline',
      () => {
        this.isDisconnected = true
      }
    )
  },
  created () {
    this.setIsLoading(true)
    this.handleHealthCheck()
    // window.location.href = 'https://stayprepared.sg/staymasked/reusable/'
  },
  beforeMount () {},
  mounted () {
    window.addEventListener('resize', this.handleScreenWidth)
    this.handleScreenWidth()
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    ...mapActions(['updateIsPayLahTile', 'updateIsLoggedIn', 'updateMobileNumbers', 'updatePayLahTileData']),
    ...mapMutations(['setScreenWidth', 'setIsLoggedIn', 'setAllowBypass']),

    handleFetchPhoneNumbers () {
      return new Promise((resolve, reject) => {
        this.getNumbers()
          .then(
            async response => {
              await this.updateMobileNumbers(response)
              resolve(response)
            },
            error => {
              this.updateIsLoggedIn(false)
              this.$cookies.remove('sm_token')
              delete this.$beepAxios.defaults.headers.Authorization
              if (this.isPayLahTile) this.$cookies.remove('sm_pl_uuid')
              reject(error)
            }
          )
      })
    },

    handleTileWithTokenAndNumber (method, body, recurred) {
      Promise.all([
        this.updateIsLoggedIn(true),
        this.updatePayLahTileData({ selected: encodeURIComponent(JSON.stringify(method)), uuid: body.uuid }),
        this.handleFetchPhoneNumbers()
      ]).then(
        values => {
          this.hasInit = true
          this.setIsLoading(false)
          // if (!recurred) this.consentShade = true
          if (!recurred) {
            this.createModal({
              title: 'Important Privacy Notice',
              message: `By proceeding, you are agreeing to our
                        <a class="underline cursor-pointer" @click="openUrl('https://stayprepared.sg/staymasked/terms-of-use/')">Terms of Use</a>
                        and
                        <a class="underline cursor-pointer" @click="openUrl('https://stayprepared.sg/staymasked/privacy-statement/')">Privacy Statement</a>`,
              btnMessage: 'Proceed',
              callback: () => this.handleAcceptConsent(),
              clickOutsideHide: false
            })
          }
        }
      )
    },

    async handlePayLahOnTile ({ uuid, code, isPayLah }) {
      this.updateIsPayLahTile(true)
      this.$router.replace({ query: { isPayLahTile: 'true' } })

      this.getPaylahUserInfo({ uuid, code })
        .then(
          async response => {
            const { success, method, phoneNumber, token, recurred } = response

            if (success && phoneNumber && !recurred) {
              this.$cookies.set('sm_token', token, 30 * 60)
              this.$beepAxios.defaults.headers.Authorization = token
              // this.$router.replace({ query: { ...this.$route.query } })
              this.handleTileWithTokenAndNumber(method, { uuid }, recurred)
            } else if (success && phoneNumber && recurred) {
              this.$beepAxios.defaults.headers.Authorization = token
              // this.$router.replace({ query: { ...this.$route.query } })
              this.handleTileWithTokenAndNumber(method, { uuid }, recurred)
            } else if (success && !phoneNumber) {
              this.$cookies.set('sm_token', token, 30 * 60)
              this.$beepAxios.defaults.headers.Authorization = token
              this.updatePayLahTileData({ selected: encodeURIComponent(JSON.stringify(method)), uuid: uuid })
              this.setIsLoading(false)
              this.$router.push({ name: 'Login', query: this.$route.query })
            } else {
              this.createModal({
                title: 'Something went wrong',
                message: 'We are experiencing issues with DBS PayLah!, please try again later.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
            }
          },
          () => {
            this.createModal({
              title: 'Something went wrong',
              message: 'We are experiencing issues with DBS PayLah!, please try again later.',
              btnMessage: 'Proceed',
              callback: () => {}
            })
          }
        )
    },

    handleScreenWidth () {
      const width = Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      )

      this.setScreenWidth(width)
    },

    async handleInitCookiesAndParams () {
      const date = new Date()
      // Current timezone midnight, use setUTCHours for epoch
      date.setHours(0, 0, 0, 0)
      // Midnight 7 days later
      date.setDate(date.getDate() + 7)
      // Set expiry date
      this.$cookies.config(date)

      const hasToken = this.$cookies.isKey('sm_token')
      if (hasToken) {
        this.setIsLoggedIn(true)
        this.$beepAxios.defaults.headers.Authorization = this.$cookies.get('sm_token')
        await this.handleFetchPhoneNumbers()
      }

      // Get query params
      var search = location.search.substring(1)

      if (search) {
        // Cast query params as object
        const queryParams = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === '' ? value : decodeURIComponent(value) })

        const isPayLahTile = queryParams.isPayLahTile

        // Handle PayLah! on-tile query params
        const uuid = queryParams.uuid || this.$cookies.get('sm_pl_uuid')
        const authCode = queryParams.authCode

        // Handle new PayLah! on-tile session
        if (uuid && authCode) {
          this.$cookies.remove('sm_token')
          this.$cookies.set('sm_pl_uuid', uuid)
          this.handlePayLahOnTile({ uuid, code: authCode, isPayLah: isPayLahTile })
        } else if (isPayLahTile && uuid) {
          // Handle PayLah! on-tile refresh
          this.handlePayLahOnTile({ uuid, code: authCode, isPayLah: isPayLahTile })
        } else if (isPayLahTile && !uuid && !authCode) {
          // Handle PayLah! on-tile to browser journey
          const query = Object.assign({}, this.$route.query)
          delete query.isPayLahTile
          this.$router.replace({ query })
          this.$cookies.remove('sm_token')
          this.$cookies.remove('sm_pl_uuid')
          this.updateIsLoggedIn(false)
          this.hasInit = true
          this.setIsLoading(false)
        } else {
          this.setIsLoading(false)
          this.hasInit = true
        }
      } else {
        this.setIsLoading(false)
        this.hasInit = true
      }
    },

    handleAcceptConsent () {
      this.consentShade = false
      this.consentModal = false
    },

    openUrl (url) {
      window.open(url, '_blank')
    },

    handleHealthCheck () {
      return new Promise((resolve, reject) => {
        this.getHealth()
          .then(
            response => {
              const { status } = response
              switch (status) {
                case 0:
                  // Restrict page, password
                  this.handleRestrictedPage()
                  break
                case 1:
                  // Functioning site, no password
                  this.handleInitCookiesAndParams()
                  break
                case 2:
                  // Maintenance, no password
                  this.redirectTo('Maintenance')
                  break
                case 3:
                  // Maintenance, bypass
                  this.handleBypass('Maintenance')
                  break
                case 4:
                  // soft-launch with bypass
                  this.handleBypass('Prelaunch')
                  break
                case 5:
                  // Redirect to campaign site
                  window.location.href = 'https://stayprepared.sg/staymasked/reusable/'
                  break
              }

              resolve(status)
            },
            error => {
              this.redirectTo('Maintenance')
              reject(error)
            }
          )
      })
    },

    handleRestrictedPage () {
      if (window.location.hostname !== 'localhost') {
        const input = prompt('Please enter the password', '')

        verifyPassword(input).then(() => {
          this.handleInitCookiesAndParams()
        }).catch(() => {
          window.location.href = 'https://www.temasekfoundation.org.sg/'
        })
      } else {
        // Localhost bypass
        this.handleInitCookiesAndParams()
      }
    },
    handleBypass (bypassRoute) {
      const bypassSession = this.$cookies.get('bpss')
      if (bypassSession) {
        this.handleInitCookiesAndParams()
      } else {
        this.setAllowBypass(true)
        this.redirectTo(bypassRoute)
      }
    },
    redirectTo (bypassRoute) {
      if ([bypassRoute].includes(this.$route.name)) {
        this.setIsLoading(false)
        this.hasInit = true
      } else {
        this.$router.push({ name: bypassRoute, query: this.$route.query })
          .then(() => {
            this.setIsLoading(false)
            this.hasInit = true
          })
      }
    }
  }
}
</script>

<style lang="scss">
@import "assets/styles/tailwind.postcss";
@import url("https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,200;0,300;0,400;0,500;0,577;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,577;1,600;1,700;1,800;1,900&display=swap");

body {
  font-family: "Muli", sans-serif;
  touch-action: manipulation;
}

@media only print {
  #app-component {
    min-height: auto;
  }
}
</style>
